<template functional>
  <div
    :ref="data.ref"
    class="base-card"
    :class="[...(Array.isArray(data.class) ? data.class : [data.class]), data.staticClass]"
    :style="[...(Array.isArray(data.style) ? data.style : [data.style]), data.staticStyle]"
    v-bind="props"
    v-on="listeners"
  >
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseCard",
});
</script>
